export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-08.39d1e4d2.jpg";